import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { mergeParams } from "../../helpers/helpers";
import Form from "../../components/form";
import MUIDataTable from "mui-datatables";

export default function AcessosApp({ history, location }) {
  const [dadosFiltros, setDadosFiltros] = useState(
    mergeParams(
      {
        profissional: "",
        escola: "",
        dataInicial: "",
        dataFinal: "",
      },
      location
    )
  );
  const [registros, setRegistros] = useState([]);
  const [comboEscolas, setComboEscolas] = useState([]);

  useEffect(() => {
    carregarComboEscolas();

    if (
      dadosFiltros.profissional ||
      dadosFiltros.escola ||
      dadosFiltros.dataInicial ||
      dadosFiltros.dataFinal
    ) {
      carregarAcessos();
    }
  }, []);

  const carregarComboEscolas = () => {
    api
      .get("escolas/listar", { ativas: true })
      .then((comboEscolas) => setComboEscolas(comboEscolas));
  };

  const carregarAcessos = (filtrosEnviar = dadosFiltros) => {
    setDadosFiltros(filtrosEnviar);

    api
      .get("relatorios/acessosAppTeachers", filtrosEnviar)
      .then((res) => setRegistros(res));
  };

  const filtros = {
    title: "Filtros",
    form: {
      profissional: {
        label: "Profissional",
        type: "text",
        space: 6,
        value: dadosFiltros.profissional,
      },
      escola: {
        label: "Escola",
        type: "select",
        emptyItem: true,
        space: 6,
        array: {
          data: comboEscolas,
          value: "nomeFantasia",
          desc: "nomeFantasia",
        },
        value: dadosFiltros.escola,
      },
      dataInicial: {
        label: "Previsão de início a partir de",
        type: "date",
        space: 6,
        value: dadosFiltros.dataInicial,
      },
      dataFinal: {
        label: "Previsão de início até",
        type: "date",
        space: 6,
        value: dadosFiltros.dataFinal,
      },
    },

    submit: {
      label: "Carregar",
      action: carregarAcessos,
    },

    urlParams: true,
    history,
    location,
  };

  return (
    <div>
      <Form formData={filtros} />
      <br />
      <MUIDataTable
        title={"Profissionais - Acessos App"}
        data={registros}
        columns={columns}
        options={options}
      />
    </div>
  );
}

const columns = [
  {
    name: "escolaNome",
    label: "Escola",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "usuarioNome",
    label: "Nome",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "ultimoAcessoApp",
    label: "Último Acesso App",
    options: {
      filter: false,
      sort: true,
    },
  },
];

const options = {
  filterType: "checkbox",
  selectableRows: "none",
  rowsPerPage: 50,
  downloadOptions: {
    filename: "acessos_app.csv",
    separator: ";",
    filterOptions: {
      useDisplayedColumnsOnly: false,
      useDisplayedRowsOnly: true,
    },
  },
  onDownload: (buildHead, buildBody, columns, data) => {
    return "\uFEFF" + buildHead(columns) + buildBody(data);
  },
};
